<ng-container *ngIf="role=== 'admin' else user">
  <div class="oi-ds-refresh">
  <button class="btn" (click)="RefreshDash()"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" /><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" /></svg> Refresh</button>
  <div class="refresh-dashboard" *ngIf="loader"><img src="../../assets/img/loderredash.gif"></div>
  </div>

    <!-- <iframe width="100%" class="iframeheight" frameBorder="0"
      src='https://ocdev.oneclick.info:9008/public/dashboards/9AA4oIijxvrjUvus2tZguelkM0uSxU4GH8GMA2WH?refresh=600&org_slug=default'></iframe>
       -->
       <iframe #iframeRef width="100%" class="iframeheight" frameBorder="0" [ngClass]="{ 'ifram-opicity': loader }"
       [src]="sanitizedUrl"></iframe>
</ng-container>
<ng-template #user>
  <div class="oi-ds-refresh">
    <button class="btn" (click)="RefreshDash()"><svg  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  class=""><path d="M20 11a8.1 8.1 0 0 0 -15.5 -2m-.5 -4v4h4" /><path d="M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4" /></svg> Refresh</button>
    <div class="refresh-dashboard" *ngIf="loader"><img src="../../assets/img/loderredash.gif"></div>
    </div>
    <iframe #iframeRef width="100%" class="iframeheight" frameBorder="0"
      [src]="sanitizedUrl"></iframe>
</ng-template>